interface Props {
  label: string;
  hint?: string;
  value: number;
  onChange(v: number): void;
  step?: number;
  min?: number;
  max?: number;
}

export function AdminNumberField({
  label,
  hint,
  value,
  onChange,
  step,
  min = 0,
  max,
}: Props) {
  return (
    <div className="adm-row">
      <label>{label}</label>
      {hint && <p className="adm-row__hint">{hint}</p>}
      <input
        className="adm-input"
        type="number"
        value={value}
        min={min}
        max={max}
        step={step}
        onChange={(e) => onChange(parseFloat(e.target.value) || 0)}
      />
    </div>
  );
}
